import classes from './SideBar.module.css';
import side_bar_img from './images/side_bar.png';
import ToggleCollapse from './ToggleCollapse';
import ToggleExpand from './ToggleExpand';
import SideBarLink from './SideBarLink';


function SideBar(props) {


    let toggle_expand = (<>
            <div style={{position: 'absolute', top: '5px', left: `${props.width-40}px`, width: '30px', height: '30px'}}>
                <ToggleExpand handleClick={props.handle_toggle} /> 
            </div>
        </>);
    
    let toggle_collapse = (<>
            <div style={{position: 'absolute', top: '5px', left: `${props.width-40}px`, width: '30px', height: '30px'}}>
                <ToggleCollapse handleClick={props.handle_toggle} /> 
            </div>
        </>);

    let sidebar_collapsed = (<>
            <div style={{width: `${props.width}px`, height: '100%', margin:'0', padding:'0', overflow:'hidden'}}>
                <img className={classes.side_bar_img} style={{height: '100%'}} src={side_bar_img} alt="side_bar"/>
                <div className={classes.side_bar_img} style={{height: '100%', width:`${props.width - 17}px`, position:'absolute', opacity: '0.9', backgroundColor:'white'}} ></div>
            </div>
        </>);

  

    
    
    let sidebar = (<>
        <div style={{width: `${props.width}px`, height: '100%', margin:'0', padding:'0', overflow:'hidden'}}>
            <img className={classes.side_bar_img} style={{height: '100%'}} src={side_bar_img} alt="side_bar"/>
            <div className={classes.side_bar_img} style={{height: '100%', width:`${props.width - 17}px`, position:'absolute', opacity: '0.9', backgroundColor:'white'}} >
                <div style={{height: '95%', width: '95%', position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)'}}>
                    <p style={{fontSize:'16px', fontWeight:'bold', margin:'0px', padding:'0px', textAlign:'left'}}>Project Overview </p>
                        <SideBarLink id='project_information' href='/' selected={props.active_link}>
                            Project Information
                        </SideBarLink>
                        <SideBarLink id='optimization_campaigns' href='/optimization_campaigns' selected={props.active_link}>
                            Optimization Campaigns
                        </SideBarLink>
                        <SideBarLink id='campaign_builder' href='/campaign_builder' selected={props.active_link}>
                            Campaign Builder
                        </SideBarLink>
                        <SideBarLink id='project_data' href='/project_data' selected={props.active_link}>
                            Project Data
                        </SideBarLink>
                        <SideBarLink id='project_tree_view' href='/project_tree_view' selected={props.active_link}>
                            Project Tree View
                        </SideBarLink>
                    <p style={{fontSize:'16px', fontWeight:'bold', margin:'0px', marginTop:'10px', padding:'0px', textAlign:'left'}}>Current Campaign</p>
                        <SideBarLink id='active_campaign_setup' href='/active_campaign_setup' selected={props.active_link}>
                            Active Campaign Setup
                        </SideBarLink>
                        {/* <SideBarLink id='campaign_dashboard' href='/campaign_dashboard' selected={props.active_link}>
                            Campaign Dashboard
                        </SideBarLink> */}
                        <SideBarLink id='optimization_cycles' href='/optimization_cycles' selected={props.active_link}>
                            Optimization Cycles
                        </SideBarLink>
                        <SideBarLink id='campaign_data' href='/campaign_data' selected={props.active_link}>
                            Campaign Data
                        </SideBarLink>
                        <SideBarLink id='campaign_tree_view' href='/campaign_tree_view' selected={props.active_link}>
                            Campaign Tree View
                        </SideBarLink>
                </div>
            </div>
        </div>
    </>);     



    let render = null
    if(props.toggle === true) {
        render = (<>
                {sidebar_collapsed}
                {toggle_expand}
            </>);
    }
    if(props.toggle === false) {
        render = (<>
                {sidebar}
                {toggle_collapse}
            </>);
    }

    return(render);

}

export default SideBar;